import api from './client'

export interface WorkOrder {
  id: string
  title: string
  description: string | null
  order_type: string
  status: 'pending' | 'assigned' | 'in_progress' | 'completed' | 'cancelled'
  priority: 'low' | 'medium' | 'high' | 'urgent'
  address: string
  location_lat: number
  location_lng: number
  assigned_to: string | null
  assigned_to_name: string | null
  created_by: string
  scheduled_date: string | null
  completed_date: string | null
  photo_path: string | null
  notes: string | null
  version: number
  created_at: string
  updated_at: string
}

export interface WorkOrderCreate {
  title: string
  description?: string
  order_type: string
  priority: string
  address: string
  assigned_to?: string
  scheduled_date?: string
  notes?: string
}

export const workordersApi = {
  list: (params?: { status?: string; assigned_to?: string; limit?: number; skip?: number }) =>
    api.get<WorkOrder[]>('/workorders', { params }),

  create: (body: WorkOrderCreate) =>
    api.post<WorkOrder>('/workorders', body),

  updateStatus: (id: string, status: string, version: number, notes?: string) =>
    api.patch<WorkOrder>(`/workorders/${id}/status`, { status, version, notes }),

  update: (id: string, body: { assigned_to?: string | null; scheduled_date?: string | null; status: string; version: number }) =>
    api.patch<WorkOrder>(`/workorders/${id}/assign`, body),

  updatePriority: (id: string, priority: string, version: number) =>
    api.patch<WorkOrder>(`/workorders/${id}/priority`, { priority, version }),

  uploadPhoto: (id: string, fileUri: string, mimeType: string) => {
    const form = new FormData()
    form.append('file', { uri: fileUri, name: 'photo.jpg', type: mimeType } as unknown as Blob)
    return api.post<{ photo_path: string }>(`/workorders/${id}/photo`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

export const ORDER_TYPES = [
  { value: 'repair',           label: 'Popravka' },
  { value: 'maintenance',      label: 'Održavanje' },
  { value: 'inspection',       label: 'Inspekcija' },
  { value: 'meter_replacement', label: 'Zamena vodomera' },
  { value: 'other',            label: 'Ostalo' },
]

export const PRIORITIES = [
  { value: 'urgent', label: 'Hitno',    color: 'bg-red-100 text-brand-critical-text' },
  { value: 'high',   label: 'Visok',    color: 'bg-orange-100 text-brand-warning-text' },
  { value: 'medium', label: 'Srednji',  color: 'bg-gray-100 text-gray-600' },
  { value: 'low',    label: 'Nizak',    color: 'bg-gray-100 text-gray-600' },
]

export const STATUSES = [
  { value: 'pending',     label: 'Na čekanju', color: 'bg-gray-100 text-gray-700' },
  { value: 'assigned',    label: 'Dodeljen',   color: 'bg-blue-100 text-blue-800' },
  { value: 'in_progress', label: 'U toku',     color: 'bg-indigo-100 text-indigo-800' },
  { value: 'completed',   label: 'Završen',    color: 'bg-emerald-100 text-emerald-800' },
  { value: 'cancelled',   label: 'Otkazan',    color: 'bg-red-100 text-red-700' },
]
